<template>
    <div>
    <!-- 移动端卡片布局 -->
    <div class="block md:hidden p-4 space-y-4">
        <div class="font-medium ml-2 text-2xl">{{ $tt('批量处理') }}</div>
        <!-- 卡片网格 -->
        <div class="grid grid-cols-1 gap-4">
            <!-- 批量设置卡片 -->
            <BatchSettings 
                :detail="detail" 
                :isLoading="isLoading"
                :cardMode="true"
                @loading-start="handleLoadingStart"
                @loading-end="handleLoadingEnd"
            />

            <!-- 标签编辑卡片 -->
            <TagEditor 
                :detail="detail" 
                :isLoading="isLoading"
                :checkedData="checkedData"
                :filePath="filePath"
                :cardMode="true"
                @loading-start="handleLoadingStart"
                @loading-end="handleLoadingEnd"
            />

            <!-- 文件操作卡片 -->
            <FileOperations 
                :detail="detail" 
                :isLoading="isLoading"
                :checkedData="checkedData"
                :filePath="filePath"
                :cardMode="true"
                @loading-start="handleLoadingStart"
                @loading-end="handleLoadingEnd"
            />

            <!-- 文本处理卡片 -->
            <TextProcessor 
                :detail="detail" 
                :isLoading="isLoading"
                :checkedData="checkedData"
                :filePath="filePath"
                :cardMode="true"
                @loading-start="handleLoadingStart"
                @loading-end="handleLoadingEnd"
            />

            <!-- 媒体处理卡片 -->
            <MediaProcessor 
                :detail="detail" 
                :isLoading="isLoading"
                :checkedData="checkedData"
                :filePath="filePath"
                :userRole="getUserRole"
                :cardMode="true"
                @loading-start="handleLoadingStart"
                @loading-end="handleLoadingEnd"
            />

            <!-- 文件索引卡片 -->
            <FileIndexer 
                :detail="detail" 
                :isLoading="isLoading"
                :checkedData="checkedData"
                :filePath="filePath"
                :userRole="getUserRole"
                :cardMode="true"
                @loading-start="handleLoadingStart"
                @loading-end="handleLoadingEnd"
            />
        </div>
    </div>

    <!-- 桌面端原有布局 -->
    <div :class="['hidden md:flex', 'flex-col', 'mt-4', detail ? 'w-48 items-start' : 'w-32 items-center']">
        <!-- 详情显示切换badge -->
        <div class="mt-1 cursor-pointer flex items-center justify-center mb-4 mx-auto">
            <div :class="['badge', 'badge-primary', 'badge-lg', detail ? 'w-16' : 'w-8']" @click="handleSetDetail">
            </div>
        </div>

        <!-- 批量设置组件 -->
        <BatchSettings 
            :detail="detail" 
            :isLoading="isLoading"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 标签编辑组件 -->
        <TagEditor 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 文件操作组件 -->
        <FileOperations 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 文本处理组件 -->
        <TextProcessor 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 媒体处理组件 -->
        <MediaProcessor 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            :userRole="getUserRole"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 文件索引组件 -->
        <FileIndexer 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            :userRole="getUserRole"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />
    </div>
</div>
</template>

<script>
import BatchSettings from '@/components/batch/BatchSettings.vue'
import TagEditor from '@/components/batch/TagEditor.vue'
import FileOperations from '@/components/batch/FileOperations.vue'
import TextProcessor from '@/components/batch/TextProcessor.vue'
import MediaProcessor from '@/components/batch/MediaProcessor.vue'
import FileIndexer from '@/components/batch/FileIndexer.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'batchAction',
    components: {
        BatchSettings,
        TagEditor,
        FileOperations,
        TextProcessor,
        MediaProcessor,
        FileIndexer
    },
    data() {
        return {
            detail: false,
            isLoading: false
        }
    },
    computed: {
        ...mapGetters(['geFullPath', 'getUserRole']),
        filePath: {
            get() {
                const fullPath = this.geFullPath
                return fullPath
            }
        },
        checkedIds: {
            get() {
                return this.$store.state.common.checkedIds
            },
            set(value) {
                this.$store.commit('setCheckedIds', value)
            }
        },
        checkedData: {
            get() {
                return this.$store.state.common.checkedData
            },
            set(value) {
                this.$store.commit('setCheckedData', value)
            }
        }
    },
    mounted() {
        const savedDetail = window.localStorage.getItem('detail')
        if (savedDetail) {
            this.detail = savedDetail === 'true'
        }
    },
    methods: {
        handleSetDetail() {
            this.detail = !this.detail
            window.localStorage.setItem('detail', this.detail ? 'true' : 'false')
        },
        
        handleLoadingStart() {
            this.isLoading = true
        },

        handleLoadingEnd() {
            this.isLoading = false
        }
    }
}
</script>

<style scoped>
</style> 